export const fadeJudge = (fadePointObj) => {
  $('.c-toTopBtn').each(function(){
    const btn = $(this);
    let scroll = $(window).scrollTop() + $(window).height(),
        fadePoint;

    if( fadePointObj ) {
      fadePoint =  fadePointObj.offset().top;
    } else {
      fadePoint =  $(window).height() * 1.2;
    }

    if( scroll >= fadePoint ) {
      btn.addClass('on');
    } else {
      btn.removeClass('on');
    }

    $(window).on('scroll', function(){
      scroll = $(window).scrollTop() + $(window).height();
      if( fadePointObj ) {
        fadePoint =  fadePointObj.offset().top;
      } else {
        fadePoint =  $(window).height() * 1.2;
      }

      if( scroll >= fadePoint ) {
        btn.addClass('on');
      } else {
        btn.removeClass('on');
      }
    });
  });
};